import TabbedPage from './TabbedPage';
import React from 'react';
import GeneralEntryLogFigma from './GeneralEntryLog/GeneralEntryLogFigma';
import CommentsEntryLogDescription from './CommentsEntryLogDescription';
import OverWindow from './TabList/OverWindow';

export default class CommentsOverWindow extends React.Component {
  static defaultProps = {
    entityId: 0,
    entityTypeId: 0,
    guidEntityId: null,
    label: 'Comments',
    clickOnCancel: () => {
      alert('Missing function');
    },
  };

  tabs = [
    {
      label: 'Comments',
      id: 'comments',
      icon: 'fa-solid fa-comment',
      component: (
        <GeneralEntryLogFigma
          description={CommentsEntryLogDescription}
          context={{
            entityTypeId: this.props.entityTypeId,
            entityId: this.props.entityId,
            guidEntityId: this.props.guidEntityId,
          }}
        />
      ),
    },
  ];

  render() {
    return (
      <OverWindow
        clickOnCancel={this.props.clickOnCancel}
        title={this.props.label}
        closeOnClickOutside={false}
      >
        <div className='verticalScroll showassignmentlistheight'>
          <TabbedPage tabs={this.tabs} />
        </div>
      </OverWindow>
    );
  }
}
